import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.showJavascriptRequiredElements();
  }

  showJavascriptRequiredElements() {
    const javascriptRequiredElements = this.element.querySelectorAll('.javascript-required');

    javascriptRequiredElements.forEach(element => {
      element.classList.remove('js-hidden');
    });
  }
}
